export default __webpack_public_path__ + "static/media/news-small-homepage-2.0a163a3e.png";